import { createApp } from "vue";

// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "vue-toastification/dist/index.css";
import "@/assets/styles/tailwind.css";
import "@/assets/styles/dap.css";

// mouting point for the whole app
import App from "@/App.vue";

// Import router
import { router } from "./router";

// Import stores
import store from "./store";

// Import plugins
import Toast from "vue-toastification";

// i18n
import { createI18n } from "vue-i18n";
import messages from "./i18n";

// Get browser language
const languages = {
  'English': 'en',
  'Español': 'es'
};

const browserLanguage = navigator.language.split("-")[0]; // e.g., 'en-US' -> 'en'
const user = JSON.parse(localStorage.getItem("user"));
const currentLanguage = user?.idioma ? languages[user.idioma] : null;

const i18n = createI18n({
  locale: currentLanguage || browserLanguage,
  fallbackLocale: "en",
  messages,
  missing: (locale, key /*, vm*/) => {
    console.warn(`Missing translation for key: ${key} in locale: ${locale}`);
    return key; // Return the key as a fallback
  },
});

// Create App
const app = createApp(App);
app.use(router);
app.use(store);
app.use(Toast, {});
app.use(i18n);
app.mount("#app");
